import Axios from "axios";
import {
    SET_ATTENDANCE_RECONCILIATION_LIST,
    UNSET_ATTENDANCE_RECONCILIATION_LIST,
    SET_EDITING_ATTENDANCE_RECONCILIATION,
    UNSET_EDITING_ATTENDANCE_RECONCILIATION,
} from "@/store/mutation-types";

import { saveUpdateAttendanceReconciliation, getAttendanceReconciliationList, getAttendanceReconciliationById } from "@/store/api";

const state = {
    getAttendanceReconciliationList: [],
    getEditingAttendanceReconciliation: null,
};

const getters = {
    getAttendanceReconciliationList(state) {
        return state.getAttendanceReconciliationList;
    },
    getEditingAttendanceReconciliation(state) {
        return state.getEditingAttendanceReconciliation;
    },
};

const mutations = {
    [SET_ATTENDANCE_RECONCILIATION_LIST](state, data) {
        state.getAttendanceReconciliationList = data;
    },
    [UNSET_ATTENDANCE_RECONCILIATION_LIST](state) {
        state.getAttendanceReconciliationList = [];
    },
    [SET_EDITING_ATTENDANCE_RECONCILIATION](state, data) {
        state.getEditingAttendanceReconciliation = data;
    },
    [UNSET_EDITING_ATTENDANCE_RECONCILIATION](state) {
        state.getEditingAttendanceReconciliation = null;
    },
};

const actions = {
    saveUpdateAttendanceReconciliation({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateAttendanceReconciliation, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getAttendanceReconciliationList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getAttendanceReconciliationList, { params: data})
                .then(function (response) {
                    commit('SET_ATTENDANCE_RECONCILIATION_LIST', response.data.data)
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_ATTENDANCE_RECONCILIATION_LIST')
                    reject(error);
                })
                .then((always) => {
                });
        });
    },

    getAttendanceReconciliationById({ commit }, data) {
        const getAttendanceReconciliationRecordById = `${getAttendanceReconciliationById}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(getAttendanceReconciliationRecordById)
                    .then((response) => {
                    resolve(response.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
